import { create } from "../../../../../common/utils/zustand_state_manager";


type State = {
    idsCentroCusto?: number[];
    status?: number;
};

type Action = {
    setIdsCentroCusto: (idsCentroCusto: number[]) => void,
    setStatus: (status: number) => void,
    clearFilters: () => void
};

export const useEntregaObrasListaFilters = create<State & Action>((set) => ({
    idsCentroCusto: [],
    status: 2,
    setStatus: (status) => set({ status }),
    setIdsCentroCusto: (idsCentroCusto) => set({ idsCentroCusto }),
    clearFilters: () => set({
        idsCentroCusto: [],
        status: 2,
    }),
}));

export const initialEntregaObrasFiltersValues: State = {
    idsCentroCusto: [],
    status: 2,
}